import React from 'react';

import { Box, Text } from '@primer/components'


export default function(props) {
  return (
    <Box class="blankslate" style={{textAlign: 'center'}}>
      <Text fontSize={'42px'}><span  role="img" aria-label="fox">🦊</span></Text>
      <h3>Done!</h3>
      <a href={props.url} target="_blank" rel="noopener noreferrer" style={{cursor: "pointer"}}>View pull request</a>
    </Box>
  )
}